module.exports = __webpack_public_path__ + "media/underling.978a4772.mp3";